import api from './api';

export interface ExerciseEvaluation {
  id?: number;
  student: number;
  student_name?: string;
  exercise: number;
  exercise_pattern_title?: string;
  status: 'success_alone' | 'success_with_help' | 'success_with_example' | 'failed_followed' | 'failed';
  rating: number;
  remarks: string;
  selected_solution: number | null;
  implemented_skill_ids: number[];
  poorly_executed_skill_ids: number[];
  missing_justifications: boolean;
  created_by?: number;
  created_by_name?: string;
  created_at?: string;
  updated_at?: string;
}

class ExerciseEvaluationService {
  async getAll(params?: any): Promise<ExerciseEvaluation[]> {
    const response = await api.get('/exercise-evaluations/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getEvaluation(id: number): Promise<ExerciseEvaluation> {
    const response = await api.get(`/exercise-evaluations/${id}/`);
    return response.data;
  }

  async create(data: Partial<ExerciseEvaluation>): Promise<ExerciseEvaluation> {
    const response = await api.post('/exercise-evaluations/', data);
    return response.data;
  }

  async update(id: number, data: Partial<ExerciseEvaluation>): Promise<ExerciseEvaluation> {
    const response = await api.patch(`/exercise-evaluations/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/exercise-evaluations/${id}/`);
  }
}

const exerciseEvaluationService = new ExerciseEvaluationService();
export default exerciseEvaluationService;
